import { manifests as entityActionManifests } from './entity-action/manifests.js';

export const manifests = [...entityActionManifests];
